export default "__VITE_ASSET__BwSbO_d4__"